import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ScrollBlockService {
  private _scrollY = 0;
  private _isBlocked = false;
  private _pendingUnblockFrame: number | null = null;

  public blockScroll(): void {
    // A close was requested but hasn't been applied to the DOM yet (still
    // waiting a couple of frames for iOS to settle) -- cancel it so a fast
    // re-open doesn't race the deferred unblock and corrupt the lock state.
    if (this._pendingUnblockFrame !== null) {
      cancelAnimationFrame(this._pendingUnblockFrame);
      this._pendingUnblockFrame = null;
    }

    if (this._isBlocked) return;

    this._scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";

    this._isBlocked = true;
  }

  public unblockScroll(): void {
    if (!this._isBlocked || this._pendingUnblockFrame !== null) return;

    // iOS Safari can leave position:fixed descendants (e.g. the mobile
    // header) stuck in a stale compositing state if the body's scroll-lock
    // styles are toggled off again before it finishes painting the locked
    // state. Waiting two frames gives it a chance to settle first.
    this._pendingUnblockFrame = requestAnimationFrame(() => {
      this._pendingUnblockFrame = requestAnimationFrame(() => {
        this._pendingUnblockFrame = null;
        this._isBlocked = false;

        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.overflow = "";

        window.scrollTo({ top: 0 });
      });
    });
  }
}
